import React, { useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import Box from "@mui/material/Box";
import CountryService, { ICountry, DEFAULT_COUNTRIES } from "../../services/CountryService";
import FlagIcon from "./FlagIcon";

interface CountrySelectProps {
  value: string;
  onChange: (code: string) => void;
  label?: string;
  fullWidth?: boolean;
}

const CountrySelect: React.FC<CountrySelectProps> = ({
  value,
  onChange,
  label = "Country",
  fullWidth = true,
}) => {
  const [countries, setCountries] = useState<ICountry[]>(DEFAULT_COUNTRIES);

  useEffect(() => {
    CountryService.getCountries()
      .then((list) => setCountries(list))
      .catch(() => setCountries(DEFAULT_COUNTRIES));
  }, []);

  return (
    <TextField
      select
      fullWidth={fullWidth}
      label={label}
      value={value}
      onChange={(e) => onChange(e.target.value)}
    >
      {countries.map((c) => (
        <MenuItem key={c.code} value={c.code}>
          <Box component="span" sx={{ mr: 1, display: "inline-flex" }}>
            <FlagIcon countryCode={c.code} size={18} />
          </Box>
          {c.name}
        </MenuItem>
      ))}
    </TextField>
  );
};

export default CountrySelect;
